import React from 'react';
import Button from '@material-ui/core/Button';

import styled from 'styled-components';
import Translatable from '../common/Translatable';

const PatternsButton = ({ variant, handleClick }) => {
    const StyledPatternsButton = styled(Button)`
          &.schnoffe-outlined{
            border: 1px solid #BA335C;
            max-height: 2.75rem;
          }
    `;

    return (
        <StyledPatternsButton onClick={handleClick} size='small' classes={{ outlined: 'schnoffe-outlined' }} variant={variant || 'outlined'} color='secondary'>
            <Translatable message='PATTERN_BUTTON_LABEL' />
        </StyledPatternsButton>
    );
};

export default PatternsButton;



// WEBPACK FOOTER //
// ./src/components/buttons/PatternsButton.js